import type { ReactNode } from 'react';
import React from 'react';
import classNames from 'classnames/bind';
import { Icon } from '../../atoms';
import { styles as inlineStyles } from './Checkbox.style';
import styles from './Checkbox.module.scss';

const cx = classNames.bind(styles);

type CheckboxProps = {
  checked: boolean;
  label: string | ReactNode;
  disabled?: boolean;
  onClick: () => void;
  extraClasses?: string;
};

export function Checkbox(props: CheckboxProps): JSX.Element {
  let icon;
  if (props.checked) {
    icon = <Icon icon={'checked'} />;
  } else {
    icon = <Icon icon={'unchecked'} />;
  }

  const onClick = () => {
    if (!props.disabled) {
      props.onClick();
    }
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }

    if (event.key === 'Escape') {
      // Prevent default action for Escape key
      event.stopPropagation();
    }
  };

  const inlineStylesForDiv = inlineStyles.row;

  if (props.disabled) {
    inlineStylesForDiv.opacity = 0.75;
  }

  let divClasses = cx('Checkbox');

  if (props.extraClasses) {
    divClasses += ` ${props.extraClasses}`;
  }

  return (
    <div
      className={divClasses}
      style={inlineStylesForDiv}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={0}
      role='checkbox'
      aria-checked={props.checked}
    >
      {icon}
      <div style={inlineStyles.text}>{props.label}</div>
    </div>
  );
}
